module.exports = __webpack_public_path__ + "static/media/texto1.03459d36.jpg";